import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { CounterComponent } from './counter/counter.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {AccordionModule} from 'primeng/primeng';
import { ToastrModule } from 'ngx-toastr';
import { StoreFrontCommonService } from './storefront/pricing/services/store-front-common.service';
import {  ModalModule } from 'ngx-bootstrap/modal';
import {ConfirmationDialogComponent} from '../app/storefront/confirmation-dialog/confirmation-dialog.component'
import { TermsandconditionsComponent } from './storefront/termsandconditions/termsandconditions.component';


@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    CounterComponent,
    FetchDataComponent,
    ConfirmationDialogComponent,
    TermsandconditionsComponent,
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    ModalModule.forRoot(),
    HttpClientModule,
    FormsModule,
    AccordionModule,
    ToastrModule.forRoot({
      closeButton: true
    }),
    BrowserAnimationsModule,
    RouterModule.forRoot([
      {
        path: '',
        loadChildren: () => import('./storefront/storefront.module').then(mod => mod.StorefrontModule)
      },
    ]),
],
entryComponents: [ConfirmationDialogComponent,TermsandconditionsComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }
